import React from "react";
import { PointsWrapper, Parah, PointsIcon } from "../ContentsStyles";
import { ParahScrollLink } from "../../Pages/PagesStyles";

const TAC_5 = () => {
  return (
    <>
      <Parah>
        We promise to provide the Platform to you with reasonable skill and care
        and to act with professional diligence for so long as we choose to offer
        the Platform. We will also take all reasonable steps to keep the
        Platform a safe and secure environment for our users. We do not promise
        to offer the Platform forever or in its current form for any particular
        period of time.
      </Parah>
      <Parah>
        The content on the Platform is mostly user generated content or provided
        by third party business users. In other words, Talents Explore is not
        the creator of most of the content on the Platform (although Talents
        Explore may produce some content). Therefore, subject to any mandatory
        regulations or laws (including sectorial regulations or laws) applicable
        to Talents Explore, Talents Explore cannot and does not promise that any
        of the content generated by users that you find on the Platform:
      </Parah>
      <PointsWrapper>
        <PointsIcon /> Is accurate, complete or up-to-date
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Does not infringe third party rights.
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Is legal or that it.
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Will not offend you.
      </PointsWrapper>
      <Parah>
        You understand and agree that the content you may see on the Platform
        does not represent our views or values and may not be suited to your
        purpose.
      </Parah>
      <Parah>
        The Platform may contain links to third party websites, advertisements,
        services, offers or other events or activities that are not provided,
        owned or controlled by Talents Explore. We do not endorse any such third
        party websites, advertisements, services, offers, events, activities,
        information, materials or products. You use them at your own risk.
      </Parah>
      <Parah>
        Provided that we have acted with professional diligence, we do not take
        responsibility for loss or damage caused by us, unless it is:
      </Parah>
      <PointsWrapper>
        <PointsIcon />
        Caused by our breach of these Terms
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Reasonably foreseeable at the time of entering into these Terms (i.e.
        either it is obvious that it will happen or if, at the time of this
        contract, it is known that it might happen).
      </PointsWrapper>
      <Parah>
        We do not take responsibility for loss or damage if it is caused by
        events beyond our reasonable control.
      </Parah>
      <Parah>
        Nothing in these Terms affects any statutory rights that you cannot
        contractually agree to alter or give up, or are legally always entitled
        to as a consumer.
      </Parah>
      <Parah>
        We do not exclude or limit in any way our liability to you where it
        would be unlawful to do so. You will always have the full protections of
        the laws that apply to you.
      </Parah>
      <Parah>
        If you are an EEA-based consumer, then EEA consumer laws provide you
        with a legal guarantee covering the Platform. If you have any questions
        about your legal guarantee, please contact us{" "}
        <ParahScrollLink smooth={true} duration={500} to="contactUS">
          here
        </ParahScrollLink>
        .
      </Parah>
      <Parah>
        In short: We will always seek to provide you with a great and safe user
        experience, but you take the Platform as it is and understand that we do
        not control everything that is on it. We also cannot promise that all
        the content posted on the Platform is to your liking. If you are an EEA
        consumer, you have a legal guarantee covering the Platform, and you can
        make a guarantee claim by contacting us.
      </Parah>
    </>
  );
};

export default TAC_5;
